import type { EdgeToEdgePlugin } from '@capawesome/capacitor-android-edge-to-edge-support';

export * from '@capawesome/capacitor-android-edge-to-edge-support';
// We are intentionally using a mutable export so that we can mimic the original import
// syntax for Capacitor plugins, while still dynamically loading the correct capacitor version.
// Don't remove or try to fix the skipcq, as this syntax is mandatory for the compatibility bridge.
// skipcq: JS-E1009
export let EdgeToEdge: EdgeToEdgePlugin;

const load = ({ EdgeToEdge: edgeToEdge }: { EdgeToEdge: EdgeToEdgePlugin }) => {
  EdgeToEdge = edgeToEdge;
};

export default load;
